import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RetailerTypeDto } from '@emi/shared/models';
import * as Constants from '@emi/shared/constants';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class RetailerTypesService {
  constructor(private httpService: HttpService) {}

  public getRetailerTypes(filterData: object): Observable<RetailerTypeDto> {
    return this.httpService.postHttp<RetailerTypeDto>(
      Constants.ServiceConstants.RETAILERS_TYPES,
      filterData
    );
  }
}
